// V4.29 — Action attendue du BOS (enum + custom).
// V4.37 — Simplification : le BOS intervient UNIQUEMENT à partir de l'offre éditée.
//         On retire les actions liées à la phase bancaire (accord banque, offre de prêt)
//         et la notion d'appel de fonds (pas de valeur opérationnelle pour le BOS).
// Partagé entre BosBlock (édition) et BosControles (affichage).

export const BOS_ACTIONS = [
  // Pipe BOS — le BOS entre dès le RDV bancaire planifié : actions phase bancaire rétablies
  { key: "wait_rdv_banque", label: "Attente RDV bancaire" },
  { key: "wait_offre", label: "Attente offre de prêt (banque)" },
  { key: "wait_reception_offre", label: "Attente réception offre par le client" },
  { key: "wait_signature_client", label: "Attente signature client" },
  { key: "wait_deblocage", label: "Attente déblocage des fonds" },
  { key: "wait_notaire", label: "Attente retour notaire" },
  { key: "wait_acte", label: "Attente acte authentique" },
  { key: "autre", label: "Autre" },
];

// V4.37 — Labels legacy conservés pour afficher correctement les dossiers historiques
// dont le BOS avait été configuré avant la simplification du workflow. Ces clés ne
// sont plus proposées dans le dropdown d'édition.
const LEGACY_LABELS = {
  wait_accord_banque: "Attente accord banque (legacy)",
  wait_appel_fonds: "Attente appel de fonds (legacy)",
};

const _LABEL_BY_KEY = {
  ...Object.fromEntries(BOS_ACTIONS.map((a) => [a.key, a.label])),
  ...LEGACY_LABELS,
};

export function bosActionLabel(action, custom) {
  if (!action) return null;
  if (action === "autre") return custom || "Autre";
  return _LABEL_BY_KEY[action] || action;
}
